import React from "react";
import image1 from "../../assets/img/homeImg4.png";
import About from "../About/About";
import Services from "../OurServices/Services";
import "./Home.css";
import Testimonial from "../TestimonialCarousel/Testimonial";
import CoursesCarousel from "../CourseCarousel/CourseCarousel";

export default function Home() {
  return (
    <>
        <div className="row justify-content-center pt-50  pb-150">
          <div className="col-md-7 col-sm-11 col-xs-12 d-flex align-items-center">
            <div className="my-2">
              <h1 className="my-2 py-2 px-3 main-text" >
                Start Learning With Us Now!
              </h1>
              <p className="my-5 px-3 font-18">
                We provide high-quality <strong>Academic Support</strong></p>
                <p className="my-1 px-3 font-18">
                  Whether you are struggling with a specific subject or simply
                  looking to improve your academic performance, we are here to
                  help. With our academic support, you can achieve your goals
                  and reach your full potential. So why wait?
                  <strong>
                    &nbsp;Start learning with us today and take the first step towards
                    a bright future!
                  </strong>
              </p>
            </div>
          </div>
          <div className="col-md-5 col-sm-11 col-xs-12">
            <div className="my-5 py-5">
              <img className="img-fluid rounded" alt="student" src={image1} />
            </div>
          </div>
        </div>
      <About show={true}/>
      <Services className="mt-5"/>
      <Testimonial show={true} className="mb-5"/>
      <div className="mb-5"></div>
      <CoursesCarousel/>
    </>
  );
}
